export type { Type } from '@packages/themes/tokens';
export { type } from '@packages/themes/tokens';
